import { useEffect, useState, useRef } from "react";
import axios from "axios";
import config from "../../../../config";

const API_URL = config.TRAFFIC;

const useTrafficMonitoringGeom = () => {
  const [data, setData] = useState({
    type: "FeatureCollection",
    features: [],
  });
  const [loading, setLoading] = useState(true);
  const isFirstLoad = useRef(true);
  const intervalId = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      // Move startTime here so it's available in finally
      const startTime = new Date();
      // console.log(`useTrafficMonitoringGeom: [${startTime.toLocaleTimeString()}] ⏳ Starting geom fetch`);

      try {
        const response = await axios.get(
          `${API_URL}/rpc/traffic_monitoring_geom`,
          { headers: { "Accept-Profile": "traffic_athens" } }
        );

        const formattedData = {
          type: "FeatureCollection",
          features: response.data,
        };
        setData(formattedData);

        // console.log(
        //   `useTrafficMonitoringGeom: [${new Date().toLocaleTimeString()}] 📦 Received geom data:`,
        //   formattedData
        // );
      } catch (err) {
        console.error(
          `useTrafficMonitoringGeom: [${new Date().toLocaleTimeString()}] ❌ Geom fetch error:`,
          err
        );
      } finally {
        const endTime = new Date();
        // console.log(
        //   `useTrafficMonitoringGeom: [${endTime.toLocaleTimeString()}] ✅ Geom fetch complete — took ${(
        //     (endTime - startTime) /
        //     1000
        //   ).toFixed(2)}s`
        // );

        if (isFirstLoad.current) {
          setLoading(false);
          isFirstLoad.current = false;
        }
      }
    };

    // initial fetch + polling every 60s
    fetchData();
    intervalId.current = setInterval(fetchData, 60_000);

    return () => clearInterval(intervalId.current);
  }, []);

  return { data, loading };
};

export default useTrafficMonitoringGeom;
